import { render, staticRenderFns } from "./addCustomerWithdrawal.vue?vue&type=template&id=2c350b68&scoped=true&"
import script from "./addCustomerWithdrawal.vue?vue&type=script&lang=js&"
export * from "./addCustomerWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./addCustomerWithdrawal.vue?vue&type=style&index=0&id=2c350b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c350b68",
  null
  
)

export default component.exports